module.exports = "<!-- Footer -->\r\n<footer class=\"site-footer\">\r\n    <div class=\"site-footer-legal\">© 2017 <a href=\"http://icheck.vn\">iCheck</a></div>\r\n    <div class=\"site-footer-right\">\r\n        Sản phẩm của <a href=\"http://icheck.vn\">iCheck</a>\r\n    </div>\r\n</footer>\r\n<!-- Core  -->"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/footer/admin-footer.template.html
// module id = ../../../../../src/app/layout/footer/admin-footer.template.html
// module chunks = main